import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import { CmsImageForUrl } from "src/components/images/CmsImageForUrl";
import Image from 'src/components/images/Image';
import { convert } from "src/components/streaming/streamingtitlewithproviders/CommonDataStructure";
import ProviderScroller from 'src/components/streaming/streamingtitlewithproviders/ProviderScroller';
import { buildFilmUrl } from 'src/lib/buildFilmUrl';
import type { FilmwebIdMovieIdentifier, StreamingContent, WatchableContent } from 'src/lib/movieinfo/movieinfotypes';
import getThemeStyles from 'src/lib/styling/getThemeStyles';
import styles from './StreamingTitleWithProviders.module.css';

//#region [Props]
type StreamingTitleWithProvidersProps = {
  data: StreamingContent | WatchableContent;
  isCinemaRelevant?: boolean;
  useOverrideCinemaRelevant?: boolean;
  movieIdentifiers?: FilmwebIdMovieIdentifier[] | null;
};
//#endregion

// MAYBE: shopPop? Tror dette kun var for debugging

//#region [Component]
export default function StreamingTitleWithProviders(t0) {
  const $ = _c(49);
  const {
    data,
    isCinemaRelevant: t1,
    useOverrideCinemaRelevant: t2,
    movieIdentifiers
  } = t0;
  const isCinemaRelevant = t1 === undefined ? false : t1;
  const useOverrideCinemaRelevant = t2 === undefined ? false : t2;
  let T0;
  let _data;
  let t3;
  let t4;
  let t5;
  let url;
  let useSanityImage;
  let useStreamingImage;
  if ($[0] !== data || $[1] !== isCinemaRelevant || $[2] !== movieIdentifiers || $[3] !== useOverrideCinemaRelevant) {
    _data = convert(data);
    const _isCinRel = useOverrideCinemaRelevant && isCinemaRelevant || _data.isCinemaRelevant;
    url = buildFilmUrl(_data, movieIdentifiers, _isCinRel);
    useSanityImage = !!_data.sanityImagePosterUrl;
    useStreamingImage = !useSanityImage && (_data.imagesPoster?.length ?? 0) > 0;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      const themeStyles = getThemeStyles(styles);
      t5 = classNames(styles.SStreamingTitle, themeStyles);
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = styles.SPosterContainer;
    T0 = FilmwebLink;
    t3 = classNames(styles.SPosterLink, {
      [styles.cinemaRelevant]: _isCinRel
    });
    $[0] = data;
    $[1] = isCinemaRelevant;
    $[2] = movieIdentifiers;
    $[3] = useOverrideCinemaRelevant;
    $[4] = T0;
    $[5] = _data;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = url;
    $[10] = useSanityImage;
    $[11] = useStreamingImage;
  } else {
    T0 = $[4];
    _data = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    url = $[9];
    useSanityImage = $[10];
    useStreamingImage = $[11];
  }
  let t6;
  if ($[13] !== _data.sanityImagePosterUrl || $[14] !== _data.title || $[15] !== useSanityImage) {
    t6 = useSanityImage && <CmsImageForUrl imageUrl={_data.sanityImagePosterUrl} alt={_data.title} sizes={SIZES} />;
    $[13] = _data.sanityImagePosterUrl;
    $[14] = _data.title;
    $[15] = useSanityImage;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== _data.imagesPoster || $[18] !== _data.title || $[19] !== useStreamingImage) {
    t7 = useStreamingImage && <Image image={_data.imagesPoster} alt={_data.title} sizes={SIZES} />;
    $[17] = _data.imagesPoster;
    $[18] = _data.title;
    $[19] = useStreamingImage;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== T0 || $[22] !== t3 || $[23] !== t6 || $[24] !== t7 || $[25] !== url) {
    t8 = <T0 className={t3} to={url} data-missingtext="Plakat mangler">{t6}{t7}</T0>;
    $[21] = T0;
    $[22] = t3;
    $[23] = t6;
    $[24] = t7;
    $[25] = url;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t4 || $[28] !== t8) {
    t9 = <div className={t4}>{t8}</div>;
    $[27] = t4;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== _data.title) {
    t10 = <h2 className={styles.STitle}>{_data.title}</h2>;
    $[30] = _data.title;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== _data.year) {
    t11 = _data.year && _data.year.length > 3 && <span className={styles.SYear}>{_data.year}</span>;
    $[32] = _data.year;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== url) {
    t12 = <header className={styles.SHeader}><FilmwebLink className={styles.SHeaderLink} to={url}>{t10}{t11}</FilmwebLink></header>;
    $[34] = t10;
    $[35] = t11;
    $[36] = url;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== _data || $[39] !== isCinemaRelevant || $[40] !== useOverrideCinemaRelevant) {
    t13 = <ProviderScroller className={styles.SProviderScroller} data={_data} isCinemaRelevant={isCinemaRelevant} useCinemaRelevantProp={useOverrideCinemaRelevant} />;
    $[38] = _data;
    $[39] = isCinemaRelevant;
    $[40] = useOverrideCinemaRelevant;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== t12 || $[43] !== t13) {
    t14 = <div className={styles.SHeaderContainer}>{t12}{t13}</div>;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== t14 || $[46] !== t5 || $[47] !== t9) {
    t15 = <article className={t5}>{t9}{t14}</article>;
    $[45] = t14;
    $[46] = t5;
    $[47] = t9;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  return t15;
}
//#endregion

const SIZES = `(min-width: 550px) 365px, 100vw`;